export const workspace = {
  routes: [
    {
      path: "/",
      component: () => import("@/modules/core/workspace/dashboard"),
    },
    {
      path: "edit",
      component: () => import("@/modules/core/workspace/workspace-form"),
    },
    {
      path: "workspaces",
      component: () => import("@/modules/core/workspace/my-workspaces-view"),
    },
    // {
    //   path: "create",
    //   component: () => import("@/modules/core/workspace/create-workspace-view"),
    // },
    {
      path: "organizations",
      component: () => import("@/modules/core/workspace/workspace-organizations-view"),
    },
    {
      path: "members",
      component: () => import("@/modules/core/workspace/workspace-members-view"),
    },
    {
      path: "member/:memberId",
      component: () => import("@/modules/core/workspace/workspace-member-info-view"),
    },
  ],
};
